/**
 * Write-off permission codes (FT10-B34, `internal/ar/permissions.go`).
 *
 * Four hands, one per act. Each is the permission its route declares
 * (`internal/ar/writeoff_routes.go`):
 *
 *   GET   /ar-write-offs, /ar-write-offs/:id,
 *         /reports/ar-write-offs, /ar-write-off-settings   ar.writeoff.read
 *   POST  /ar-write-offs, PATCH /ar-write-offs/:id,
 *         POST /ar-write-offs/:id/submit                    ar.writeoff.propose
 *   PUT   /ar-write-off-settings                            ar.writeoff.approve (step-up MFA)
 *   POST  /ar-write-offs/:id/post and /reverse              ar.writeoff.post    (step-up MFA)
 *
 * The decision itself (approve or reject) is made in the Approvals Inbox under doc type
 * `ar.write_off`, not on these screens.
 */
export const AR_WRITE_OFF_PERMISSIONS = {
  read: 'ar.writeoff.read',
  propose: 'ar.writeoff.propose',
  approve: 'ar.writeoff.approve',
  post: 'ar.writeoff.post',
} as const
